export interface PessoaItem {
  nome: string;
  id: string;
  tenant?: {
    id: string;
    nome: string;
  } | null;
}

export enum PessoaTipo {
  Fisica = "fisica",
  Juridica = "juridica",
}
